import styled from '@emotion/styled';
import { screenSizes } from 'src/assets/styles/Literals';

export const WeddingRequestComponent = styled.div`
  margin: 20px auto;
  background-color: white;
  border-radius: 16px;
  max-width: 80vw;
  padding: 40px 50px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);

  .requirements-box {
    margin-top: 20px;
    background: #fafafa;
    padding: 30px;
    border-radius: 12px;
    border: 1px solid #eee;
  }

  h2 {
    margin-top: 20px;
    color: #2c3e50;
    font-weight: 600;
  }

  .section-header {
    margin-bottom: 30px !important;
    .icon {
      color: #3498db;
    }
    .sub.header {
      color: #7f8c8d;
      font-weight: normal;
    }
  }

  .error {
    color: #e74c3c;
    &.error-message {
      font-weight: 600;
      background: #fdf0ed;
      padding: 12px;
      border-radius: 8px;
      margin: 10px 0;
    }
  }

  .button-container {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }

  .navigation-buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
    padding-top: 20px;
    border-top: 1px solid #eee;

    .ui.button {
      min-width: 120px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;

      &.secondary {
        background: #95a5a6;
        &:hover {
          background: #7f8c8d;
        }
      }
    }
  }

  .not-fulfilled-container {
    p {
      padding: 20px 0;
    }
    .button-container {
      margin-top: 10px;
    }
  }

  label {
    margin-top: 10px;
    color: #2c3e50;
  }

  .checkbox {
    padding: 5px 12px;
    border-radius: 8px;
    transition: all 0.2s ease;
    .ui.checkbox {
      label {
        margin-right: 20px;
        padding: 0 0 0 25px;
        font-size: 15px;
        line-height: 1.5;
        color: #2c3e50;
        &:hover {
          color: #3498db;
        }
      }
    }
  }

  .ui.button {
    margin-top: 20px;
    background: #3498db;
    color: white;
    padding: 12px 24px;
    border-radius: 8px;
    font-weight: 500;
    transition: all 0.2s ease;
    &:hover {
      background: #2980b9;
      transform: translateY(-1px);
    }
  }

  .form-section {
    background: white;
    padding: 25px;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    margin: 20px 0;

    .field {
      margin-bottom: 20px;

      label {
        font-weight: 500;
        color: #2c3e50;
      }

      input,
      select,
      textarea {
        border-radius: 8px !important;
        border: 1px solid #ddd !important;
        padding: 12px !important;
        transition: all 0.2s ease;

        &:focus {
          border-color: #3498db !important;
          box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2) !important;
        }
      }
    }
  }

  .read-doc-container {
    .questions-container {
      max-width: 75%;
      background: white;
      padding: 25px;
      border-radius: 12px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    }
    .couple-photo-container {
      label {
        width: 270px;
        height: 200px;
      }
    }
    .checkbox {
      padding: 5px 12px;
      border-radius: 8px;
      transition: all 0.2s ease;
      &:hover {
        background: #f8f9fa;
      }
    }
    .note {
      color: #34495e;
      line-height: 1.6;
      margin-bottom: 20px;
      a {
        color: #3498db;
        text-decoration: none;
        font-weight: 500;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  @media only screen and (max-width: 700px) {
    max-width: 100vw;
    padding: 20px;
    .read-doc-container {
      .questions-container {
        max-width: 100%;
        padding: 15px;
      }
    }
    .requirements-box {
      padding: 20px;
    }
    .navigation-buttons {
      flex-direction: column;
      gap: 10px;

      .ui.button {
        width: 100%;
      }
    }
  }
`;

export const StepperContainer = styled.div`
  text-align: center;
  margin: 40px 0;
  padding: 30px;
  background: #fafafa;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

  p {
    color: #2c3e50;
    font-size: 18px;
    margin-bottom: 30px;
    font-weight: 500;
  }

  @media (max-width: ${screenSizes.tablet}) {
    margin: 20px 0;
    padding: 20px 15px;

    p {
      font-size: 16px;
      margin-bottom: 20px;
    }
  }
`;

export const Stepper = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;
  flex-wrap: wrap;
  max-width: 900px;
  margin: 0 auto;
  position: relative;

  @media (max-width: ${screenSizes.tablet}) {
    gap: 10px;
    padding: 0 10px;
  }

  @media (max-width: ${screenSizes.mobile}) {
    flex-direction: column;
    align-items: center;
    gap: 30px;
  }
`;

export const Step = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 140px;
  position: relative;

  &.current-step {
    .circle {
      border-color: #3498db;
      background-color: #3498db;
      color: white;
      transform: scale(1.1);
    }
    .label {
      color: #3498db;
      font-weight: 600;
    }
  }

  .circle-container {
    display: block;
    position: relative;
    width: 60px;
    height: 60px;
    margin-bottom: 15px;

    .circle {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      border: 2px solid ${(props) => (props.completed ? '#4caf50' : '#e0e0e0')};
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 24px;
      background-color: ${(props) => (props.completed ? '#4caf50' : '#fff')};
      color: ${(props) => (props.completed ? '#fff' : '#757575')};
      z-index: 2;
      position: absolute;
      transition: all 0.3s ease;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

      &:hover {
        transform: scale(1.05);
      }

      .icon {
        margin: 0;
        font-size: 24px;
      }
    }

    .line {
      width: 100px;
      height: 2px;
      background-color: ${(props) => (props.completed ? '#4caf50' : '#e0e0e0')};
      position: absolute;
      top: 30px;
      left: 60px;
      z-index: 1;
      transition: all 0.3s ease;

      @media (max-width: 968px) {
        display: none;
      }
    }
  }

  .label {
    margin-top: 10px;
    font-size: 14px;
    line-height: 1.4;
    color: ${(props) => (props.completed ? '#2c3e50' : '#757575')};
    font-weight: ${(props) => (props.completed ? '500' : 'normal')};
    min-height: 40px;
    display: flex;
    align-items: center;
    text-align: center;
    transition: all 0.3s ease;
    padding: 0 5px;

    @media (max-width: ${screenSizes.tablet}) {
      font-size: 13px;
      min-height: 35px;
    }

    @media (max-width: ${screenSizes.mobile}) {
      font-size: 14px;
      min-height: auto;
      margin-bottom: 10px;
    }
  }

  &:hover {
    .circle {
      transform: scale(1.05);
    }
    .label {
      color: #2c3e50;
    }
  }

  @media (max-width: ${screenSizes.tablet}) {
    width: 140px;
  }

  @media (max-width: ${screenSizes.mobile}) {
    width: 100%;
    flex-direction: row;
    justify-content: flex-start;
    padding-left: 20px;

    .circle-container {
      margin-bottom: 0;
      margin-right: 15px;
    }

    .label {
      margin-top: 0;
      text-align: left;
    }
  }
`;
